import styled from 'styled-components';

import { color } from '../../assets/styles/colors';

export const Wrapper = styled.div`
	width: 100%;
`;

export const Content = styled.div`
	background-color: ${color.ligthGray};
	padding: 15px 30px;
	font-size: 24px;
	font-weight: 300;
	color: ${color.gray};
`;

export const Title = styled.div`
	width: 100%;
	height: 60px;
	font-size: 24px;
	font-weight: 300;
	color: ${color.gray};
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: ${color.white};
	padding: 0 30px;
	cursor: pointer;
`;
